
<ng-container *ngIf="!hasValue">
  <div class="button-link-wrapper">
    <button class="btn btn-primary btn-link" (click)="edit()">add</button>
  </div>
</ng-container>

<ng-container *ngIf="hasValue && isSameDay">
  <p>Scheduled for: <b>{{ workOrder.scheduledStartTime | date : 'E dd/MM/yy' }}</b></p>
  <p>Start Time: <b>{{ workOrder.scheduledStartTime | date : 'HH:mm' }}</b></p>
  <p>End Time: <b>{{ workOrder.scheduledEndTime | date : 'HH:mm' }}</b></p>
  <div class="button-link-wrapper">
    <button class="btn btn-primary btn-link" (click)="edit()">edit</button>
  </div>
</ng-container>

<ng-container *ngIf="hasValue && !isSameDay">
  <p>Start Time: <b>{{ workOrder.scheduledStartTime | date : 'E dd/MM/yy HH:mm' }}</b></p>
  <p>End Time: <b>{{ workOrder.scheduledEndTime | date : 'E dd/MM/yy HH:mm' }}</b></p>
  <div class="button-link-wrapper">
    <button class="btn btn-primary btn-link" (click)="edit()">edit</button>
  </div>
</ng-container>
